import React from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { useEntityNavigate as useNavigate } from '../../navigation/navigation'
import EntityForm from '../../components/EntityForm'
import EntityHistory from '../../components/EntityHistory'
import { Button } from '../../components/ui'
import './Company.css'

function StageEdit() {
  const { contractId, id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const isNew = location.pathname.endsWith('/new') || id === 'new'
  const editId = isNew ? null : id

  return (
    <div className="company-page">
      <div className="page-header">
        <Button variant="ghost" onClick={() => navigate(`/contract/${contractId}`)} className="btn-back">
          ← Назад к договору
        </Button>
      </div>
      <EntityForm
        entityType="stages"
        entityId={editId}
        context={{ contractId }}
        title={isNew ? 'Новый бюджет стадии' : 'Редактирование бюджета стадии'}
      />
      {editId && <EntityHistory entityType="stages" entityId={editId} />}
    </div>
  )
}

export default StageEdit
